import { useNavigate } from "react-router-dom";
import { Layout } from "../layout/Layout";
import { ProviderRegistrationForm } from "../components/wizard/provider-registration/ProviderRegistrationForm";

export function RegistrationProvider() {
	const navigate = useNavigate();

	return (
		<Layout>
			<div className="bg-white px-4 py-8">
				<div className="mx-auto w-full max-w-6xl">
					<ProviderRegistrationForm
						mode="public"
						variant="page"
						onClose={() => navigate("/registro")}
						successRedirectTo="/login"
					/>
				</div>
			</div>
		</Layout>
	);
}
